import { Link } from 'gatsby';
import { getIssuePath } from '../../../model/post';
import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

function Intro({ className, issue }) {
  const {
    tghpwipIssuesTaxonomyFeaturedImage: issueImage,
    name: issueName,
    slug: issueSlug,
    tghpwipIssuesTaxonomySymposiumTabTitle: tabTitle,
    tghpwipIssuesTaxonomySymposiumOngoing: ongoing,
    tghpwipIssuesTaxonomySymposiumIntroTitle: introTitle,
    tghpwipIssuesTaxonomySymposiumIntroBody: introBody,
  } = issue;

  const image = (
    <>
      {issueImage?.nodes.length > 0 && (
        <GatsbyImage
          image={issueImage?.nodes[0]?.gatsbyImage}
          sizes="(min-width: 720px) 50vw"
          alt=""
        />
      )}
    </>
  );

  return (
    <div className={`symposium-intro ${className}`}>
      <Link
        to={getIssuePath(issueSlug)}
        className={`symposium-intro__titles ${className}-titles intro-titles intro-titles--invert`}
      >
        <div className="intro-titles__label">{issueName}</div>
        {tabTitle && <div className="intro-titles__name">{tabTitle}</div>}
      </Link>
      {!!Number(ongoing) && (
        <div className={`symposium-intro__ongoing ${className}__intro-ongoing`}>Ongoing</div>
      )}
      {introTitle && (
        <div className={`symposium-intro__title ${className}-title`}>{introTitle}</div>
      )}
      {introBody && <div className={`symposium-intro__body ${className}-body`}>{introBody}</div>}
      <div className={`symposium-intro__image ${className}-image`}>{image}</div>
    </div>
  );
}

export default Intro;
